const UNEXPECTED = 'ארעה שגיאה בלתי צפויה'

// Axios reports only the status it got back, so a rejection that explains itself —
// a name already taken, content that can no longer be edited — is in the server's
// own message rather than in the error the client caught.
export function resolveErrorMessage(error) {
    return error?.response?.data?.error?.message
        || error?.message
        || UNEXPECTED
}
